import { combineReducers } from 'redux';
import { authentication } from './useraction.reducer';
import { ipInfo } from './ipInfo.reducer';
import { notificationCountInfo,notificationApiCallInfo } from "./notification.reducer"

const rootReducer = combineReducers({
  authentication, ipInfo, notificationCountInfo,notificationApiCallInfo,
});

export default rootReducer;